<template>
  <section class="section searchHospitalSec">
    <SearchHospital />
  </section>
</template>

<script lang="ts">
import SearchHospital from '@/components/block/SearchHospital.vue'

export default {
  name: 'HomeMapSearch',

  components: {
    SearchHospital
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
</style>
